
  // Function to disable unwanted links
  function disableUnwantedLinks(container) {
    const links = container.querySelectorAll('.jdgm-rev__prod-link');

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href && !/(men|kids|jr)/i.test(href)) {
        // Disable the link
        link.removeAttribute('href');
        link.style.pointerEvents = 'none';
        link.style.color = 'gray'; // Optional: style it to look disabled
        link.style.textDecoration = 'none';
        link.style.cursor = 'default';
      }
    });
  }

  // Initial run for existing reviews
  document.addEventListener("DOMContentLoaded", function () {
    disableUnwantedLinks(document);

    // Setup MutationObserver to catch new reviews added to the DOM
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.classList.contains('jdgm-rev')) {
            disableUnwantedLinks(node);
          }
        });
      });
    });

    // Observe the container that holds the reviews
    const reviewContainer = document.querySelector('body'); // or more specific container if known
    if (reviewContainer) {
      observer.observe(reviewContainer, {
        childList: true,
        subtree: true
      });
    }
  });
